import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_product_categories,
  get_product_categories_error,
  get_product_categories_success,
  create_product_category,
  create_product_category_error,
  create_product_category_success,
  edit_product_category,
  edit_product_category_success,
  edit_product_category_error,
  get_all_categories_success,
  get_all_categories_error,
  get_all_categories,
  delete_product_category,
  delete_product_category_success,
  delete_product_category_error
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';
import { FileUploadToCloud } from '@app/services/fileUploadService';

function* getProductCategoriesSagas({ payload }) {
  try {
    const { page = 1, limit = 100, searchString } = payload;
    let search = ``;
    if (searchString) {
      search = `&search=${searchString}`;
    } else {
      search = ``;
    }
    const requestRes = yield call(
      api.get,
      `/product_categories?page=${page}&limit=${limit}${search}`
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_product_categories_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error ? error.toString() : error.response.data.message);
    yield put({
      type: get_product_categories_error.type
    });
  }
}

function* createProductCategorySagas({ payload }) {
  try {
    const { data, onClose } = payload;
    let doc = { ...data };

    if (data.image) {
      const uploadresult = yield call(FileUploadToCloud, data.image);
      if (uploadresult) {
        doc.image = uploadresult.url;
      }
    }

    const requestRes = yield call(api.post, '/product_categories', doc);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    yield put({
      type: create_product_category_success.type,
      payload: response
    });
    onClose();
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: create_product_category_error.type
    });
  }
}

function* updateCategorySagas({ payload }) {
  try {
    const { id, data, onClose } = payload;
    let doc = { ...data };

    if (typeof data.image === 'object') {
      const uploadresult = yield call(FileUploadToCloud, data.image);
      if (uploadresult) {
        doc.image = uploadresult.url;
      }
    } else if (data.image) {
      doc.image = data.image;
    }

    const requestRes = yield call(api.put, `/product_categories/${id}`, doc);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    yield put({
      type: edit_product_category_success.type,
      payload: response
    });
    onClose();
  } catch (error) {
    toast.error(error.response);
    yield put({
      type: edit_product_category_error.type
    });
  }
}

function* getAllCategoriesSaga({ payload }) {
  try {
    const { page = 1, limit = 100 } = payload;
    const requestRes = yield call(
      api.get,
      `/product_categories?page=${page}&limit=${limit}`
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_all_categories_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error ? error.toString() : error.response.data.message);
    yield put({
      type: get_all_categories_error.type
    });
  }
}

function* deleteProductCategorySagas({ payload }) {
  try {
    const requestRes = yield call(api.delete, `/product_categories/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    yield put({
      type: delete_product_category_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: delete_product_category_error.type
    });
  }
}

function* productCategoriesSagas() {
  yield takeEvery(get_product_categories.type, getProductCategoriesSagas);
  yield takeEvery(create_product_category.type, createProductCategorySagas);
  yield takeEvery(edit_product_category.type, updateCategorySagas);
  yield takeEvery(get_all_categories.type, getAllCategoriesSaga);
  yield takeEvery(delete_product_category.type, deleteProductCategorySagas);
}

export default productCategoriesSagas;
